import script from "./PersonalCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalCenter.vue?vue&type=script&setup=true&lang=js"

import "./PersonalCenter.vue?vue&type=style&index=0&id=74c5e259&scoped=true&lang=css"
script.__scopeId = "data-v-74c5e259"

export default script